import Vue from 'vue'
import Router from 'vue-router'
import home from '@/view/home/index'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: '_home',
      redirect: '/home',
      component: home,
      children:[
        {
          path: '/home',
          name: 'home',
          meta: {
            title: '印先森',
          },
          component: home
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js